import { render, staticRenderFns } from "./wyModalEditIntervention.vue?vue&type=template&id=56e5e56b&"
import script from "./wyModalEditIntervention.vue?vue&type=script&lang=js&"
export * from "./wyModalEditIntervention.vue?vue&type=script&lang=js&"
import style0 from "./wyModalEditIntervention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports